import {throttle} from "throttle-debounce";
import util from "@/common/js/util";

/**
 * 用于控制子组件的显示隐藏
 */
export let visibleMixin = {
    data() {
        return {
            actId: util.id(),
            visible: false,
            delay: 16,
        };
    },
    props: {},
    methods: {
        show() {
            this.visible = true;
            // 不能在show的时候重置表单，否则编辑的时候打开没数据，也不能在close的时候重置表单，否则传出去的数据会受到影响
            // if(this.resetForm && (typeof this.resetForm === 'function')){
            //     this.resetForm();
            // }
            this.$nextTick(() => {
                this.$refs.form?.clearValidate();
            });
        },
        close() {
            this.visible = false;
            this.actId = util.id();
        },
        closed() {
            let $form = this.$refs.form;
            if ($form) {
                this.$nextTick(() => {
                    $form.clearValidate();
                });
            }
            this.$emit("closed");
        },
    },
}

export let modelMixin = {
    props: {
        value: {
            required: false,
            default() {
                return {};
            }
        }
    },
    data() {
        return {
            form: {},
            valid: false,
        }
    },
    methods: {
        save({close = true, formRef = null, copyForm = true}) {
            // 一秒内防止重复操作
            if(this.__dlgSaving__){
                return;
            }
            this.__dlgSaving__ = true;
            window.setTimeout(() => {
                this.__dlgSaving__ = false;
            }, 1000);

            console.log("-----", JSON.stringify(this.form));
            // 防止关闭后清空表单的同时，把弹窗外的数据一起清空
            const updateData = copyForm ? util.deepCopy(this.form) : this.form;
            if (formRef) {
                formRef.validate(valide => {
                    this.valid = valide;
                    if (valide) {
                        this.$emit("update:form", updateData);
                        this.$emit("save", updateData);
                    }
                })
            } else {
                this.$emit("update:form", updateData);
            }
            if (this.valid && close && this.close) {
                this.close();
            }
        }
    }
}

/**
 * 用于父组件控制子组件的显示隐藏
 */
export let visibleParentMin = {
    methods: {
        refShow(ref) {
            this.$refs[ref]['show']();
        }
    }
}

/**
 * 用于页面的节流滚动
 */
export let throttleScrollMixin = {
    methods: {
        throttleSyncPosition: throttle(this.delay, false, () => this.syncPosition()),
        handleScroll() {
            // 参考element的写法，提高渲染效率
            let that = this;
            let raf = window.requestAnimationFrame;
            if (!raf) {
                this.throttleSyncPosition();
            } else {
                raf(that.syncPosition)
            }
        },
    }
}


/**
 * el-table 日期格式化
 * @type {{methods: {formatDate: (function(*, *): *)}}}
 */
export let elRowDateFormatterMixin = {
    methods: {
        formatDate: function (row, col) {
            let data = row[col.property];
            if (!data) {
                return data;
            }
            let dataType = typeof data;
            console.log("(typeof data)", dataType)
            if (dataType === "object") {
                return util.formatDate.format(data, "yyyy-MM-dd hh:mm:ss");
            } else if (dataType === "number") {
                return util.formatDate.format(new Date(data), "yyyy-MM-dd hh:mm:ss");
            } else if (dataType === "string") {
                return util.formatDate.format(new Date(data), "yyyy-MM-dd hh:mm:ss");
            } else {
                console.error("不支持的时间格式", data);
                return data;
            }
        }
    }
}

export let elRowBooleanFormatterMixin = {
    methods: {
        formatBoolean: function (row, col) {
            let data = row[col.property];
            if (data === null || data === undefined) {
                return '';
            }
            return data ? '是' : '否';
        }
    }
}

export const formTipMixin = {
    beforeDestroy() {
        this.$el.removeEventListener('mousemove', this.handle);
        this.lastTarget = null;
    },
    mounted() {
        this.$el.addEventListener('mousemove', this.handle);
    },
    methods:{
        handle(ev){
            if (ev.target.tagName !== 'INPUT') {
                if (this.lastTarget !== null) {
                    this.lastTarget = null;
                }
                return;
            }
            if (this.lastTarget === ev.target) {
                return;
            }
            this.lastTarget = ev.target;
            this.lastTarget.setAttribute('title', ev.target.value);
        }
    }
}

export let editFormMixin = {
    data() {
        this.readonly = (this.type === 'view');
        return {
        }
    },
    props: {
        type: util.prop(false, 'add'),// // view edit
        fieldCtl: util.prop(false, {}),// // view edit
    },
    methods:{
        isEditMode(){
            return this.type === 'edit';
        },
        isAddMode(){
            return this.type === 'add';
        },
        isCopyMode(){
            return this.type === 'copy';
        }
    },
    watch: {
        'type': function (val) {
            console.log('type change ___ ', val);
            this.readonly = val === 'view';
            this.fieldCtl.__all__ = this.isAddMode();
        },
    }
}

export let fieldCtlMixin = {
    data() {
        return {
            fieldCtl: {},
        }
    },

    methods:{
        initFieldCtl(){
            let col = this.table.scene.table.col;
            col.forEach(c => {
                this.fieldCtl[c.field] = 2;//c.level||0;
            });
        }
    }
}


export let multiRowTable = {
    data(){
        return {
            dataListName: "必须覆盖",

            currentRow: null,
            currentRowItem: null,
            currentRowEl: null,
            selectType: '',
        }
    },
    methods: {
        rowClick(event,row,type,item){
            let maxLoop = 10
            let rowEl = event.target;
            while (true) {
                if (rowEl.classList.contains('el-row')) {
                    break;
                }
                rowEl = rowEl.parentElement;
                if (maxLoop-- < 0) {
                    return;
                }
            }
            this.selectType = type;
            this.currentRow = row;
            this.currentRowItem = item;
            if (this.currentRowEl) {
                this.currentRowEl.classList.remove("cell-selected");
            }
            this.currentRowEl = rowEl;
            rowEl.classList.add("cell-selected");
        },
        addSubRow({key = 'infoList'}) {
            this.childRow({mainRow:this.currentRow,key});
        },
        removeRow({row=null,selectType=null,key='infoList',item=null}) {
            if(row){
                this.currentRow = row;
            }
            if (!this.currentRow) {
                return;
            }
            console.log('removeRow', this.selectType, this.currentRow);
            if (this.selectType === '1' || selectType === 1) {
                // 选中基础信息的时候 删除主记录
                this.removeRowFromList(this.form[this.dataListName], this.currentRow);
                this.rowChange();
            } else if (this.selectType === '2' || selectType === 2) {
                // 选中货物信息的时候删除子记录
                this.removeRowFromList(this.currentRow[key], item||this.currentRowItem);
                this.rowChange();
                // 子记录全部删除的时候同时删除主记录
                if(!this.currentRow[key].filter(e=>!e.isDel).length){
                    this.removeRowFromList(this.form[this.dataListName], this.currentRow);
                    this.rowChange();
                }
            }
            if (this.currentRowEl) {
                this.currentRowEl.classList.remove("cell-selected");
            }
            this.currentRow = null;
            this.currentRowItem = null;
            this.currentRowEl = null;
            this.selectType = "";
        },
        addMain() {
            let items = this.newRow();
            this.form[this.dataListName].push(items);
            this.rowChange();
        },
        childRow({mainRow,key='children'}) {
            if (!mainRow[key]) {
                mainRow[key] = [];
            }
            mainRow[key].push({isDel: 0});
        },
        rowChange(){},
        // 需要覆盖
        newRow() {
            return {
                isDel: 0,
                children: [
                    {
                        isDel: 0,
                    }
                ]
            }
        }
    }
}


/**
 * 远程搜索组件通用mixins
 * @type {{data(): {remoteMethod: null, choose: {}, label: string, list: [], key: string}, methods: {init(*): void, query(*): *, change(*): void, focus(): void, queryArg(*): {}}, mounted(): void, props: {data: {default(): {}}, readonly: {default(): boolean}, binding: {default(): {}}}}}
 */
export let objSelectMixins = {
    props: {
        placeholder:{
            default() {
                return "请选择";
            }
        },
        size:{
            default() {
                return "";
            }
        },
        data: {
            default() {
                return {};
            }
        },
        binding: {
            default() {
                return {};
            }
        },
        readonly: {
            default() {
                return false;
            }
        },
        bindingOn:{
            default(){
                return []
            }
        },
    },
    data(){
        return {
            key: "",
            label:'',
            remoteMethod: null,
            list: [],
            choose: {}
        }
    },
    mounted() {
        const KEY = this.key;
        console.green("Select options of " + this.$options.name + " mounted, key is " + this.binding[KEY]);
        let handleName = (name) => {
            if (this.loading) {
                return ""
            }
            this.loading = true;
            let dataCodeVal = this.data[this.binding[KEY]];
            console.green('query .............. StoreSelect,dataCodeVal=' + dataCodeVal);
            let chooseKey = this.choose[KEY];
            if (name && name === chooseKey) {
                console.log({chooseKey, name},"search keywords is equals current choose val");
                this.loading = false;
                return "";
            }
            if (!name && (dataCodeVal && dataCodeVal === chooseKey)) {
                console.log('name is empty and dataCodeVal == chooseKey',{dataCodeVal,chooseKey});
                this.loading = false;
                return "";
            }
            this.query(name).then(res => {
                let list = res.module || [];
                if (list.lztxRespDTOS) {
                    list = list.lztxRespDTOS;
                }
                this.list = list;
                this.loading = false;
                if (dataCodeVal) {
                    this.choose = this.list.find(e => {
                        if(e[KEY] === dataCodeVal){
                            console.log('====>', e[KEY], dataCodeVal, e);
                            return true;
                        }
                        return false
                    })||"";
                    console.log('choose _______', JSON.stringify(this.choose), this.choose, dataCodeVal, KEY);
                }
            }).catch(e => {
                this.loading = false;
                this.list = [];
                console.log(e);
            });
        }
        this.remoteMethod = throttle(500, handleName);
        let init = () => {
            let data = this.data;
            let bd = this.binding;
            let keys = Object.keys(this.binding);
            let v = {}
            keys.forEach(k => {
                v[k] = data[bd[k]];
            });
            this.list = [v];
            this.choose = v
        }
        this.$watch('data.' + this.binding[KEY], (val)=>{
            console.log(this.$options.name + ' ________change', val, this.choose[KEY], this.binding[KEY]);
            if (!val) {
                this.choose = "";
                console.log("____val is blank");
                return;
            }
            if (val === this.choose[KEY]) {
                console.log("____val is equals");
                return;
            }
            init();
        });
        init();
    },
    methods: {
        queryArg(name){
            return {[this.key]: name}
        },
        query(name) {
            return this.axios.post(this.url, this.queryArg(name));
        },
        init(key) {
            if (key) {
                this.query(key).then()
                let list = this.list.filter(e => e.key === key);
                if (list && list.length) {
                    this.choose = list[0];
                } else {
                    console.warn('not found', this.choose, this.list, key);
                }
            } else {
                this.choose = {};
            }
        },
        focus(){
            console.debug('focus ... ', this.choose);
            if (this.choose && this.choose[this.key]) {
                return;
            }
            this.remoteMethod("");
        },
        visibleChange(v){
            console.log('visibleChange', v);
            if(!v){
                return;
            }
            // console.debug('focus ... ', this.choose);
            // if (this.choose && this.choose[this.key]) {
            //     return;
            // }
            this.remoteMethod("");
        },
        change(val) {
            if (!val) {
                val = {};
            }
            let data = this.data;
            let bd = this.binding;
            let keys = Object.keys(this.binding);
            keys.forEach(k => {
                data[bd[k]] = val[k];
            });
            this.$emit('input');
            this.$emit('change',val);
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/mixins.js